<template>
    <div class="page">
        <div class="success-icon">
            <img src="@/assets/new/newCopy/icon04.png" alt="">
        </div>
        <div class="success-msg">充值激活成功，已到账260</div>
        <div class="success-msg-small">您可以在【查询充值】中 查看 余额金额和活动余额情况</div>
        <van-button type="primary" block round color="#397EF5" style="width: 173px;" @click="activation">前去激活</van-button>
   </div>
</template>
<script>
export default{
    data(){
        return{
        }
    },
    methods:{
        activation(){
            this.$router.push({
                path: '/new/order'
            })
        }
    }
}
</script>
<style lang="less" scoped>
.page{
    background: #fff;
    height:100%;
    .success-icon{
        width:64px;
        height:64px;
        margin: 66px auto 22px;
        img{
            width:100%;
            height:100%;
        }
    }
    .success-msg{
        height: 25px;
        text-align: center;
        margin-bottom:22px;
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #28292D;
        line-height: 25px;
    }
    .success-msg-small{
        width:219px;
        margin: 0 auto 44px;
        color: #999;
        font-size: 14px;
        line-height: 22px;
        text-align: center;
    }
    .van-button{
        margin: 0 auto;
    }
}
</style>